"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _dateFormatting = _interopRequireDefault(require("@insided/shared/utils/dateFormatting"));

var InviteStatusCell = function InviteStatusCell() {
  return function (_ref) {
    var invite = _ref.invite;
    if (!invite) return 'Not invited';
    var createdAt = invite.createdAt,
        validUntil = invite.validUntil;
    if (new Date(validUntil) < new Date()) return 'Invite expired';
    return (0, _preact.h)("div", null, "Invited on ", (0, _dateFormatting.default)(new Date(createdAt).getTime() / 1000 | 0));
  };
};

var _default = InviteStatusCell;
exports.default = _default;